import AssignSelector from '@components/AssignSelector';
import Button from '@components/Buttons/Buttons';
import UserCirclePlus from '@components/Icons/UserCirclePlus';
import { AssignToPersonType, Expression } from '@typings/api-models';
import usePopover from '@/hooks/usePopover';
import { AnimatePresence, m } from 'framer-motion';

import { ReactElement, useEffect, useState } from 'react';
import s from './AssigneeSelectorWorkflowInvoices.module.scss';

type Assignee = { key: string; label: string; type: AssignToPersonType };
type AssigneeSelectorWorkflowInvoicesProps = {
  availableAssignees: Assignee[];
  invoiceData: {
    id: string;
    referenceId: string;
    title: string;
    expression?: Expression | null;
    workflowInvoiceAssigneeIds?: string[] | null;
  };
  handleSubmit: (workflowInvoiceAssigneeIds: string[]) => void;
};

const AssigneeSelectorWorkflowInvoices = ({ availableAssignees, invoiceData, handleSubmit }: AssigneeSelectorWorkflowInvoicesProps): ReactElement => {
  const { isOpen, setIsOpen, menuRef, triggerRef } = usePopover('bottom-left', true);

  const [assigneesDataFromInvoiceData, setAssigneesDataFromInvoiceData] = useState<{ key: string; label: string }[]>([]);

  const [currentSelectedPeople, setCurrentlySelectedPeople] = useState<{ key: string; label: string }[]>([]);
  const [hasBeenInteractedWith, setHasBeenInteractedWith] = useState<boolean>(false);

  useEffect(() => {
    if (invoiceData?.workflowInvoiceAssigneeIds?.length) {
      const persons: Assignee[] = [];
      availableAssignees?.forEach(person => {
        if (invoiceData?.workflowInvoiceAssigneeIds?.includes(person.key)) {
          persons.push(person);
        }
      });
      setAssigneesDataFromInvoiceData(persons);
    } else {
      setAssigneesDataFromInvoiceData([]);
    }
  }, [invoiceData]);

  const handleChangePeople = (newPeople: { key: string; label: string }[]): void => {
    setHasBeenInteractedWith(true);
    if (newPeople.length === 0) {
      setCurrentlySelectedPeople([]);
    } else {
      setCurrentlySelectedPeople(newPeople);
    }
  };

  const handleUpdateInvoiceConditions = (assigneesSelected: string[]): void => {
    handleSubmit(assigneesSelected?.length ? assigneesSelected : []);
  };

  const handleAssigneeSelectorModalHandle = (): void => {
    if (isOpen) {
      setCurrentlySelectedPeople([]);
    }
    setIsOpen(!isOpen);
  };

  const handleUpdateAutoAssignees = async (assigneesSelected: string[]): Promise<void> => {
    setHasBeenInteractedWith(false);
    handleAssigneeSelectorModalHandle();
    handleUpdateInvoiceConditions(assigneesSelected);
  };

  return (
    <>
      <Button
        ref={triggerRef}
        isWrapper
        className={s.invite}
        onClick={() => {
          handleAssigneeSelectorModalHandle();
        }}
      >
        <UserCirclePlus size={16} weight="fill" />
      </Button>
      <AnimatePresence>
        {isOpen && (
          <m.div style={{ minWidth: 200 }} initial={{ opacity: 0, y: 8 }} exit={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 4 }} ref={menuRef}>
            <AssignSelector
              onChange={handleChangePeople}
              handleSave={handleUpdateAutoAssignees}
              items={availableAssignees.map(person => ({
                ...person,
                isChecked: hasBeenInteractedWith
                  ? currentSelectedPeople.some(item => item.key === person.key)
                  : assigneesDataFromInvoiceData.some(item => item.key === person.key),
              }))}
            />
          </m.div>
        )}
      </AnimatePresence>
    </>
  );
};
export default AssigneeSelectorWorkflowInvoices;
